import { useContext } from 'react';
import { Auth0Context } from '../contexts/auth0';

export default function useAuth0() {
  return useContext(Auth0Context);
}
